/**
 * The paper Skeleton's placeholder colour is `bg-paper2` — bone, which on the
 * vault's dark ground reads as a row of lit panels rather than a gap waiting
 * to be filled. Same component, repainted for the dark room.
 */
export function VaultSkeleton({ className = "" }: { className?: string }) {
  return <div className={`animate-pulse rounded bg-white/[0.07] ${className}`} />;
}
